<h2 mat-dialog-title>Organisatie verwijderen</h2>
<mat-dialog-content>
  <p>Weet je zeker dat je deze organisatie wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="outlined" (click)="onUserClick(false)">Annuleren</button>
  <button matButton="filled" class="danger-button" (click)="onUserClick(true)" cdkFocusInitial>Verwijderen</button>
</mat-dialog-actions>
